import React, { useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import Login from '../../components/login/Login';
import PlainOverlay from '../../components/plainOverlay/PlainOverlay';
import ValidationException from '../../exceptions/ValidationException';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const blocRef = useBlocRef('loginBloc');
  const history = useHistory();
  const [validationErrors, setValidationErrors] = useState({});
  const [isMediphanyWorkspace, setIsMediphanyWorkspace] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isShowOverlay, setIsShowOverlay] = useState(false);
  const [useRecaptcha, setUseRecaptcha] = useState(false);

  useEffect(() => {
    const isMediphanySub = blocRef.current.isMediphanyWorkspace$.subscribe(setIsMediphanyWorkspace);
    const isShowOverlaySub = blocRef.current.isShowOverlay$.subscribe(setIsShowOverlay);
    return () => {
      isMediphanySub.unsubscribe();
      isShowOverlaySub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async ({ email, password }, recaptchaToken) => {
    try {
      await blocRef.current.login(email, password, recaptchaToken);
      setErrorMessage('');
    } catch (exception) {
      if (exception.statusCode === 429) {
        setErrorMessage('You exceeded the number of attempts allowed. The login will be blocked for 10 minutes.');
        return;
      }

      if (exception instanceof ValidationException) {
        setValidationErrors(exception.errors);
      } else {
        const { numberOfPasswordAttempt, maxAttempts, message, activateCaptcha } = exception;

        setUseRecaptcha(!!activateCaptcha);

        if (maxAttempts && numberOfPasswordAttempt) {
          const remaining = maxAttempts - numberOfPasswordAttempt;
          setErrorMessage(`${message}. ${remaining} attempt${remaining > 1 ? 's' : ''} remaining`);
        } else {
          setErrorMessage(message);
        }
      }
    }
  };

  const handleTokenLogin = (token, isDemo) => {
    blocRef.current.loginToken(token, isDemo);
  };

  const handleRegister = () => {
    history.push('/register');
  };

  return (
    <>
      <PlainOverlay show={isShowOverlay} />
      <Login
        isMediphanyWorkspace={isMediphanyWorkspace}
        isLoggingIn$={blocRef.current.isLoggingIn$}
        onSubmit={handleSubmit}
        onRegister={handleRegister}
        useRecaptcha={useRecaptcha}
        onTokenLogin={handleTokenLogin}
        validationErrors={validationErrors}
        errorMessage={errorMessage}
      />
    </>
  );
};
